import React from "react";
import "../../App.css";

export default function Destinations() {
  return <h1 className="Destinations">Destinations</h1>;
}
